<template>
	<LoginLayout>
		<div class="form-container vtd-login">
			<b-col
				class="login-form-box col-md-12 col-lg-6 order-1 order-lg-2 p-3"
			>
				<b-form
					class="login-form"
					@submit.stop.prevent="onSubmit"
				>
					<div class="vtd-card-block">
						<div
							class="logo-login"
							:style="{
								backgroundImage:
									'url(https://cdn.trailfinders.com/p3h68obuvf_tf-viewtrail.png)',
							}"
						/>
						<h5 class="vtd-card-title form-title">YOUR TRAVEL PLANS ON THE GO</h5>
						<FlashMessage />
						<b-form-group
							label-for="input-username"
							class="vtd-form-group"
						>
							<b-form-input
								id="input-username"
								v-model.trim="$v.form.username.$model"
								type="text"
								class="vtd-form-control vtd-form-control-lg vtd-login vtd-case"
								:state="validateState('username')"
								placeholder="Surname"
							/>
						</b-form-group>
						<b-form-group
							label-for="input-bookingnumber"
							class="vtd-form-group"
						>
							<b-form-input
								id="input-bookingnumber"
								v-model.trim="$v.form.bookingNumber.$model"
								type="text"
								class="vtd-form-control vtd-form-control-lg vtd-login vtd-case"
								:state="validateState('bookingNumber')"
								placeholder="Trailfinders Reference"
							/>
						</b-form-group>
						<b-form-checkbox
							id="remember-me"
							v-model="form.rememberMe"
							class="switch-box"
							switch
							size="sm"
							name="remember-me"
							value="true"
							unchecked-value="false"
						>
							Remember me
						</b-form-checkbox>
						<div class="vtd-footer">
							<b-button
								type="submit"
								class="mb-3 vtd-btn vtd-btn-success vtd-btn-login vtd-btn-xl vtd-btn-block vtd-btn-center vtd-text-white vtd-login"
							>
								Login
							</b-button>
							<b-button
								class="portal-btn vtd-btn vtd-btn-xl vtd-btn-block vtd-btn-center"
								type="button"
								@click="goToCorporate"
								>Corporate Travel Management Portal</b-button
							>
						</div>
						<div class="image-container">
							<div>
								<img
									src="https://cdn.trailfinders.com/vt-logo-orange-btn-colour-square.png"
								/>
							</div>
							<div class="mobile-img">
								<a
									href="https://play.google.com/store/apps/details?id=com.trailfinders.viewtrail&hl=en_GB&gl=US&pli=1"
									target="_blank"
								>
									<img
										src="https://cdn.trailfinders.com/k8g3jhbctd_btn-google-play.jpg"
										class="img-block"
									/>
								</a>
								<a
									href="https://apps.apple.com/gb/app/viewtrail-trailfinders/id1180019820"
									target="_blank"
								>
									<img
										src="https://cdn.trailfinders.com/qp0rjwat5i_btn-app-store.jpg"
										class="img-block"
									/>
								</a>
							</div>
						</div>
					</div>
				</b-form>
			</b-col>
		</div>
	</LoginLayout>
</template>

<script>
	import { required } from "vuelidate/lib/validators";
	import LoginLayout from "@/partials/login-layout";
	import FlashMessage from "@/partials/flash-message";
	import { getSite } from "@/lib/utilities";
	import { mapActions } from "vuex";
	export default {
		components: {
			LoginLayout,
			FlashMessage,
		},
		data() {
			return {
				site: getSite(),
				version: process.env.PACKAGE_VERSION || "0",
				form: {
					username: "",
					bookingNumber: "",
					rememberMe: false,
				},
			};
		},
		validations: {
			form: {
				username: {
					required,
				},
				bookingNumber: {
					required,
				},
			},
		},
		methods: {
			validateState(name) {
				const { $dirty, $error } = this.$v.form[name];
				return $dirty ? !$error : null;
			},
			...mapActions({
				login: "auth/loginBookingNumberAction",
			}),
			goToCorporate() {
				this.$router.push("/corporate");
			},
			async onSubmit() {
				this.$v.form.$touch();
				if (this.$v.form.$anyError) {
					return;
				}
				const res = await this.login(this.form);
				const isAuth = this.$store.getters['auth/isAuthenticated'];
				if (res || isAuth) {
					this.$router.push('/landing');
				}
			},
		},
	};
</script>
<style scoped>
	@import "./styles.scss";
</style>
